import Auth from "@aws-amplify/auth";

export async function Init(): Promise<void> {
  const config = {
    stage: "gamma",
    aws_cognito_region: "us-east-1",
    aws_cognito_identity_pool_id: "us-east-1:8845376e-41c2-434f-968e-4779eca60e74",
    aws_user_pools_id: "us-east-1_2BKKY3fgg",
    aws_user_pools_web_client_id: "7drasopoieaf4sbm9gmlfp83rp",
    Auth: {
      identityPoolId: "us-east-1:8845376e-41c2-434f-968e-4779eca60e74",
      region: "us-east-1",
      userPoolId: "us-east-1_2BKKY3fgg",
      userPoolWebClientId: "7drasopoieaf4sbm9gmlfp83rp",
    },
    oauth: {
      domain: `whs-eap-gamma-na.auth.us-east-1.amazoncognito.com`,
      redirectSignIn: "https://gamma.na.safety-genie.whs.amazon.dev",
      redirectSignOut: "https://gamma.na.safety-genie.whs.amazon.dev",
      scope: ["openid", "email", "profile"],
      responseType: "code",
    },
  };
  Auth.configure(config);
}
